<template>
  <div class="newsdetailApp" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent :idx='4'></headComponent>
    <div class="h"></div>
    <div class="proBg" :style="'background: url('+newbg+') no-repeat center;'">
      <div class="at">{{setNewsDetail.title}}</div>
    </div>
    <div class="main">
      <div class="con" v-html="setNewsDetail.content"></div>

      <div class="con">
        发布时间：{{setNewsDetail.createtime}}
      </div>
    </div>
    <footComponent></footComponent>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        newbg:require('../../../assets/images/newsbg.jpg'),
        setNewsDetail:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getNewsDetail()
    },
    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getNewsDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id
        $.ajax({
          type:'post',
          url:that.$host+'home/index/newsDetail',
          data:{
            id:id
          },
          dataType:'json',
          success:function(data){
            that.setNewsDetail = data.data;
            that.fullscreenLoading = false;
          }
        })
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .newsdetailApp .el-message-box{
    width:30%
  }
  .newsdetailApp{
    width:100%;
    margin:0 auto;
    background:#F7F9FA
  }
  .newsdetailApp .h{
    height:96px
  }
  .newsdetailApp .proBg{
    height: 28.06vw;
    color:#fff;
    font-size: 2vw;
    text-align:center;
    position: relative;
  }
  .newsdetailApp .proBg .at{
    position: absolute;
    width:100%;
    bottom: 2.708vw;
  }
  .newsdetailApp .main{
    max-width:1600px;
    margin:0 auto;
    background:#fff;
    font-size:16px;
    color: #333;
    padding: 30px 0
  }
  .newsdetailApp .main .title{
    text-align:center;
    font-size:22px;
    padding-bottom:25px;
    font-weight:bold
  }
  .newsdetailApp .main .con{
    width:90%;
    margin:0 auto
  }
  .newsdetailApp .main p {
    font-size: 16px;
    color: #333;
    letter-spacing: 1px;
    line-height: 24px;
    text-indent: 2em;
    margin-bottom:15px
  }
  .newsdetailApp .main img {
    display: block;
    margin: 0 auto;
    width:100% !important
  }
  
  @media only screen and (max-width: 1199px) {
    .newsdetailApp .header,.newsdetailApp .h{
      height:60px;
    }
    .newsdetailApp .header .logo img{
      height:25px;
      margin:17.5px 12px 0 12px
    }
    .newsdetailApp .header .nav{
      text-align:right
    }
    .newsdetailApp .header .nav li{
      margin:0 1.8vw
    }
    .newsdetailApp .header .nav .close{
      display:none
    }
    .newsdetailApp .header .nav a{
      line-height:60px;
      font-size:14px
    }

    .newsdetailApp .proBg{
      font-size:18px;
    }
    .newsdetailApp .main dl dd{
      width:50%
    }
  } 
</style>